import React__default from 'react';
import classnames from 'classnames';
import { QuantityItem } from './QuantityItem.js';

const QuantityContainer = ({ items , selected , itemView , handleClick  })=>{
    const Component = itemView || QuantityItem;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "quantity-container"
    }, items.map((item)=>/*#__PURE__*/ React__default.createElement("button", {
            key: item.value,
            className: classnames('quantity-container__item', {
                _is_selected: selected.value === item.value
            }),
            onClick: ()=>handleClick(item)
            ,
            "data-t": item.value
        }, /*#__PURE__*/ React__default.createElement(Component, {
            className: "quantity-container",
            label: item.label,
            subtext: item.subtext,
            aside: item.aside
        }))
    ));
};

export { QuantityContainer };
//# sourceMappingURL=QuantityContainer.js.map
